import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
    selector: '[flashlightText]'
})
export class FlashlightMaskDirective implements OnInit, OnDestroy {
    @Input() animationDuration = 1.4; // in seconds
    @Input() highlighted = false;
    @Input() activeForSeconds: number | null = null; // Duration in seconds to keep the effect active

    private styleEl: HTMLStyleElement | null = null;
    private timeoutId: any = null; // For storing the setTimeout ID

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        // Add the container class
        this.renderer.addClass(this.el.nativeElement.parentElement, 'flashlight-text-container');

        // Add the flashlight text class
        this.renderer.addClass(this.el.nativeElement, 'flashlight-text');

        // Add highlighted class if needed
        if (this.highlighted) {
            this.renderer.addClass(this.el.nativeElement, 'highlighted');
        }

        // Create and append the styles to the document
        this.addStyles();

        // If activeForSeconds is set, remove the class after the duration
        if (this.activeForSeconds !== null && this.activeForSeconds > 0) {
            this.timeoutId = setTimeout(() => {
                this.renderer.removeClass(this.el.nativeElement, 'flashlight-text');
                // Optionally, you might want to remove the highlighted class as well
                // if (this.highlighted) {
                //     this.renderer.removeClass(this.el.nativeElement, 'highlighted');
                // }
            }, this.activeForSeconds * 1000);
        }
    }

    private addStyles() {
        if (document.head.querySelector('style[data-flashlight-directive-styles]')) {
            return;
        }

        this.styleEl = this.renderer.createElement('style');
        this.renderer.setAttribute(this.styleEl, 'data-flashlight-directive-styles', 'true');

        // Set the CSS content - REVERTED TO YOUR ORIGINAL ANIMATION CSS
        const css = `
      .flashlight-text-container {
        opacity: 0.7;
      }
      
      .flashlight-text {
        background-color: #000; /* Your original fallback */
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        background-image: linear-gradient(to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 50%,    /* Your original gradient */
          rgba(255, 255, 255, 1) 50.1%,  /* Your original gradient */
          rgba(255, 255, 255, 0) 100%);
        background-size: 200% 100%;      /* Your original background-size */
        background-position: 100% 0;
        animation: flashlight-highlight-animation ${this.animationDuration}s linear infinite;
      }
      
      .flashlight-text.highlighted {
        opacity: 1; /* Your original opacity for highlighted */
      }
      
      @keyframes flashlight-highlight-animation { /* Your original keyframes */
        0% {
          background-position: 100% 0;
        }
        100% {
          background-position: -100% 0;
        }
      }
    `;

        this.renderer.appendChild(this.styleEl, this.renderer.createText(css));
        this.renderer.appendChild(document.head, this.styleEl);
    }

    ngOnDestroy() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        // Basic cleanup for this instance
        if (this.el && this.el.nativeElement) {
            this.renderer.removeClass(this.el.nativeElement, 'flashlight-text');
            if (this.highlighted) {
                this.renderer.removeClass(this.el.nativeElement, 'highlighted');
            }
            //  this.renderer.removeClass(this.el.nativeElement.parentElement, 'flashlight-text-container');
        }
        // Note: Global style tag is not removed to prevent issues if other instances use it.
        // A more complex cleanup would involve reference counting for the global style tag.
    }
}
